module.exports = __webpack_public_path__ + "img/pdf.323ae548.png";